export default "__VITE_ASSET__3e94e1b7__"